/**
 * This file is a component for E2 UI Customization (This is subject to change based off of mediaType)
 */

import React, {useState, useEffect} from 'react';
import { Grid, FormControlLabel, Checkbox, Tooltip} from '@material-ui/core';
import DoneOutlineIcon from '@material-ui/icons/DoneOutline';

export default function EmailDisposition(props)
{
    const [emailDisposition, setEmailDisposition] = useState(false);

    /** Set disposition to value being passed through props */
    useEffect(() => {
        console.log(props.value);
        setEmailDisposition(props.value);
    },[props.value])

    // Handle hold checkbox change
    const handleEmailDisposition = () => {
        setEmailDisposition(!emailDisposition);
        props.onChange(!emailDisposition);
    }

    return(
        <div>
            <Grid container direction="row" alignItems="center">
                <Grid item>
                    <FormControlLabel
                    control={
                        <Checkbox
                        checked={emailDisposition}
                        onChange={handleEmailDisposition}
                        name="emailDisposition"
                        color="primary"
                        />
                    }
                    label="Disposition"
                    />
                </Grid>
                <Grid item>
                    <Tooltip title="Give permission for email dispositions">
                        <DoneOutlineIcon color="primary"/>
                    </Tooltip>
                </Grid>

            </Grid>
            
        </div>
    );
}

